<template>
  <section class="production">
    <header>
      <h2>{{production.title}}</h2>
      <p class="subtitle">
        {{production.subtitle}}
      </p>
    </header>
    <div class="container text-center">
      <img v-lazy="production.image" class="hidden-xs" alt="">
      <img v-lazy="production.imageMobile" class="visible-xs" alt="">
    </div>
  </section>
</template>

<script>
export default {
  name: 'Production',
  props: {
    production: Object
  },
  data: () => ({
  }),
  computed: {},
  created () {},
  methods: {}
}
</script>

<style lang="scss">

</style>
